import { useEffect, useState } from 'react';
import { useLocalStorage } from 'react-use';
import Cookies from 'js-cookie';
import geocodeByPlaceId from '../utils/geocodeByPlaceId';

function getLocationPLaceId() {
  const windowParams = new URL(document.location).searchParams;
  // The value in params should suppress the Cookies value.
  return windowParams.get('placeId') || Cookies.get('USER_PLACE_ID');
}

export default function useCompanyLocation(localStorageKey) {
  const [savedLocation, setSavedLocation] = useLocalStorage(localStorageKey);
  const [, setLocation] = useState(savedLocation);
  useEffect(() => {
    const placeId = getLocationPLaceId();
    if (placeId && !savedLocation) {
      geocodeByPlaceId(placeId)
        .then((res) => {
          setLocation(res);
          setSavedLocation(res);
        })
        // eslint-disable-next-line no-console
        .catch((error) => console.error(error));
    }
  }, []);

  return { savedLocation, setSavedLocation };
}
